export const environment = {
    production: false,
    apiEndPoint:'http://192.168.81.128/api/v0',
    apiToken:"b48971e7647f6297a7842f3bd4c73403"
  };